
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dmca-takedown-service",
      function () {
        return require("private-next-pages/dmca-takedown-service.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dmca-takedown-service"])
      });
    }
  